import { render, staticRenderFns } from "./mobile-product-category-list.vue?vue&type=template&id=f5321cb6&lang=pug&"
import script from "./mobile-product-category-list.vue?vue&type=script&lang=js&"
export * from "./mobile-product-category-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports